module.exports = __webpack_public_path__ + "static/img/A41.d2a65acc.jpg";